import { isTodayInTimezone } from "@compass/shared/schema/dateUtils";
import { parseISO } from "date-fns";
import { timeAgo } from "./timeAgo";

export const formatISODate = (dateString: string, timeZone: string) => {
    const date = parseISO(dateString);
    const options: Intl.DateTimeFormatOptions = {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone,
    };
    if (!isTodayInTimezone(date, timeZone)) {
        options.month = "short";
        options.day = "numeric";
    }
    return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const formatISODateRelative = (dateString: string) => {
    const date = parseISO(dateString);
    return timeAgo.format(date);
};
